export default {
  workflowsData: [],
  allowedTags: {},
  totalLocalBalance: undefined,
  invoicesCountOutstanding: undefined,
  selected: [],
  stats: {},
  ruleStats: {},
};
